import React from 'react';
import ReactDOM from 'react-dom/client';
import { message } from 'antd';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Configure Ant Design message globally
message.config({
  top: 24,
  duration: 3,
  maxCount: 3,
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
